import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ShieldCheck, XCircle, Loader2, Search } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { api } from "../lib/api";
import { PageHero } from "../components/FormKit";

export const CertificateVerify = () => {
  const { certificateId } = useParams();
  const [id, setId] = useState(certificateId || "");
  const [state, setState] = useState(certificateId ? { status: "checking" } : { status: "idle" });

  const check = async (cid) => {
    setState({ status: "checking" });
    try {
      const { data } = await api.get(`/certificate/verify/${cid}`);
      setState({ status: "valid", cert: data.certificate });
    } catch { setState({ status: "invalid" }); }
  };

  useEffect(() => { if (certificateId) check(certificateId); }, [certificateId]);

  return (
    <div data-testid="certificate-verify-page">
      <PageHero eyebrow="TAVEN Academy" title="Verify a Certificate" subtitle="Confirm the authenticity of any TAVEN SYSTEM LLC certificate using its verification ID." />
      <section className="py-14 px-4 mx-auto max-w-xl">
        <form onSubmit={(e) => { e.preventDefault(); if (id) check(id); }} className="flex gap-2 mb-8">
          <div className="flex items-center gap-2 flex-1 border border-black/15 px-3 h-12"><Search className="w-4 h-4 text-muted-foreground" /><input value={id} onChange={(e) => setId(e.target.value)} placeholder="e.g. TAVEN-XXXXXXXXXX" data-testid="verify-input" className="bg-transparent outline-none text-sm w-full" /></div>
          <button data-testid="verify-submit" className="bg-taven-black text-white px-6 font-bold uppercase tracking-wider text-sm hover:bg-taven-orange transition-colors">Verify</button>
        </form>

        {state.status === "checking" && <div className="text-center py-8"><Loader2 className="w-8 h-8 animate-spin mx-auto text-taven-gold" /></div>}
        {state.status === "valid" && (
          <div className="border-2 border-green-500 bg-green-50 p-6" data-testid="verify-valid">
            <div className="flex items-center gap-2 text-green-700 font-bold"><ShieldCheck className="w-5 h-5" /> Valid Certificate</div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 mt-4">
              <div className="flex-1 space-y-1 text-sm">
                <p><span className="text-muted-foreground">Student:</span> <strong>{state.cert.student_name}</strong></p>
                <p><span className="text-muted-foreground">Course:</span> <strong>{state.cert.course_title}</strong></p>
                <p><span className="text-muted-foreground">Issued:</span> {new Date(state.cert.issued_date).toLocaleDateString()}</p>
                <p><span className="text-muted-foreground">Certificate ID:</span> {state.cert.certificate_id}</p>
                <p className="text-xs text-taven-gold uppercase tracking-widest pt-2">TAVEN SYSTEM LLC</p>
              </div>
              <div className="text-center shrink-0" data-testid="verify-qr">
                <div className="bg-white p-2 border border-black/10 inline-block">
                  <QRCodeSVG value={`${window.location.origin}/verify/${state.cert.certificate_id}`} size={104} fgColor="#111111" level="M" />
                </div>
                <p className="text-[10px] text-muted-foreground mt-1 uppercase tracking-wider">Scan to verify</p>
              </div>
            </div>
          </div>
        )}
        {state.status === "invalid" && <div className="border-2 border-red-400 bg-red-50 p-6 flex items-center gap-2 text-red-700 font-bold" data-testid="verify-invalid"><XCircle className="w-5 h-5" /> No certificate found with that ID.</div>}
      </section>
    </div>
  );
};

export default CertificateVerify;
